import React from "react";
import {formatDateAndTime, ProjectName} from "../../context/function";

export default function GeneralFooter() {
    const currentYear = formatDateAndTime(new Date(), 'year_only')
    return (
        <footer className="print:hidden border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-4 shadow-sm transition-colors duration-200" id="kt_footer">
            <div className="mx-auto flex max-w-full flex-col items-center justify-between px-4 sm:px-6 lg:flex-row lg:px-8">
                <div className="order-2 text-sm text-slate-600 dark:text-slate-400 lg:order-1">
                    <span className="font-semibold">{currentYear} &copy;</span>
                    <a 
                        href="#" 
                        target="_blank" 
                        rel="noreferrer"  
                        className="ml-1 font-semibold text-slate-800 dark:text-slate-200 transition-colors hover:text-indigo-600 dark:hover:text-indigo-400"
                    >
                        {ProjectName}
                    </a>
                </div>
            </div>
        </footer>
    )
}